React = require 'react'
_ = require 'underscore'
# Using `create_board` here to share strings with parent template
t = require('views/internal/recup-with-helpers')('create_board')
helpers = require './helpers'

{ createBackgroundStyle } = helpers

module.exports = class BackgroundChooserComponent extends React.Component
  displayName: 'BackgroundChooserComponent'

  constructor: (props) ->
    # XXX: duplicated state
    @state =
      background: null
    super props

  componentDidMount: ->
    setTimeout (=> @chooserElem?.focus()), 10

  render: t.renderable ->
    { colors, photos, onColorChooserTriggerClick, onPhotoChooserTriggerClick, selectedBackground } = @props

    containsSelectedBackground = @containsSelectedBackground.bind @
    renderBackgroundItem = @renderBackgroundItem.bind @

    setChooserElem = (elem) => @chooserElem = elem

    t.div '.background-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      t.section ->
        t.header '.background-chooser-header', ->
          t.h1 '.background-chooser-heading', ->
            t.format 'colors'
          t.a '.quiet-button', {
            href: '#'
            onClick: onColorChooserTriggerClick
          }, ->
            t.format 'see more'

        t.ul '.background-grid', ->
          colors = colors.slice(0, 6)
          if selectedBackground.isColor && !containsSelectedBackground(colors)
            colors = [selectedBackground].concat colors.slice(1)
          colors.forEach renderBackgroundItem

      t.section ->
        t.header '.background-chooser-header', ->
          t.h1 '.background-chooser-heading', ->
            t.format 'photos'
          t.a '.quiet-button', {
            href: '#'
            onClick: onPhotoChooserTriggerClick
          }, ->
            t.format 'see more'

        t.ul '.background-grid', ->
          photos = photos.slice(0, 6)
          if selectedBackground.isPhoto && !containsSelectedBackground(photos)
            photos = [selectedBackground].concat photos.slice(1)
          photos.forEach renderBackgroundItem

  renderBackgroundItem: (bg) ->
    isSelected = bg.value ==
      if @state.background?
        @state.background.value
      else
        @props.selectedBackground.value

    onBackgroundClick = =>
      # XXX: duplicated state
      @setState { background: bg }
      @props.onSelect bg

    t.li '.background-grid-item', ->
      t.button '.background-grid-trigger', {
        className: t.classify {
          'is-photo': bg.isPhoto
          selected: isSelected
        }
        key: bg.value
        onClick: onBackgroundClick
        role: 'button'
        style: createBackgroundStyle bg
        title: bg.value if bg.isColor
      }, ->
        if isSelected
          t.icon 'check'

  containsSelectedBackground: (backgrounds) ->
    _.find backgrounds, (bg) => bg.value == @props.selectedBackground.value



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/background-chooser-component.coffee